import React from "react";
import { useTranslation } from "react-i18next";

export const Contact = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <div id="contact" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2> { t("Contact.contactTitle") } </h2>
          </div>
          <div className="grid-container" style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "20px",
          }}>
            <div className="card" style={{ 
              padding: "20px", 
              textAlign: "left", 
              display: "flex",
              flexDirection: "column"
            }}>
              <div style={{ flexGrow: 1 }}>
                <h4 style={{ marginBottom: "40px" }}>{t("Contact.ourContacts")}</h4>
                <p>
                  <span style={{ color: "white" }}>
                    <i className="fa fa-envelope"></i> Email
                  </span>{" "}
                  <br />
                  <a href={`mailto:${props.data ? t("Contact.email") : "loading"}`} style={{ color: "#D3D3D3" }}>
                    {props.data ? t("Contact.email") : "loading"}
                  </a>
                </p>
                <p style={{ marginTop: "20px" }}>
                  <span style={{ color: "white" }}>
                    <i className="fab fa-telegram-plane"></i> Telegram
                  </span>{" "}
                  <br />
                  <a href={props.data ? t("Contact.telegram_chat_link") : "/"} style={{ color: "#6AC6B8", textDecoration: "underline" }}>
                    {props.data ? t("Contact.telegram_chat") : "loading"}
                  </a>
                </p>
              </div>
              <div style={{ 
                marginTop: "auto",
                marginBottom: "20px"
              }}>
                <a 
                  href={props.data ? t("Contact.telegram_chat_link") : "/"} 
                  className="btn-demo"
                  style={{ 
                    display: "block",
                    width: "100%",
                    textAlign: "center",
                    marginTop: "20px",
                    marginBottom: "0px",
                    marginLeft: 0,
                    marginRight: 0
                  }}
                >
                  {t("Contact.joinTelegram") || "вступить в Telegram"}
                </a>
              </div>
            </div>
            <div className="card" style={{ 
              padding: "20px", 
              textAlign: "left",
              background: "linear-gradient(135deg, #338278 0%, #152b27 100%)",
              color: "white",
              display: "flex",
              flexDirection: "column"
            }}>
              <div style={{ flexGrow: 1 }}>
                <h2>{t("Contact.readyToTry")}</h2>
                <p>{t("Contact.leaveContact")}</p>
              </div>
              <button 
                className="btn-demo" 
                onClick={props.openPopup} 
                style={{ 
                  marginTop: "auto",
                  marginBottom: "20px",
                  marginLeft: 0, 
                  width: "100%"
                }}
              >
                {t("Contact.requestDemo")}
              </button>
            </div>
            <div className="card" style={{ 
              padding: "20px", 
              textAlign: "left",
              display: "flex",
              flexDirection: "column"
            }}>
              <h4 style={{ marginBottom: "40px" }}>{t("Contact.partners")}</h4>
              <div style={{ flexGrow: 1 }}>
                <div className="circle" style={{ marginBottom: "30px" }}>
                  <a href={props.data ? t("Contact.partner1_link") : "/"}>
                    <img src="img/MIPT_Logo_rus.png" alt="Partner 1" draggable="false" style={{ height: "40px", width: "auto" }} />
                  </a>
                </div>
                <div className="circle">
                  <a href={props.data ? t("Contact.partner2_link") : "/"}>
                    <img src="img/factor_group_logo.png" alt="Partner 2" draggable="false" style={{ height: "30px", width: "auto" }} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>&copy; {t("Contact.copyright")}</p>
        </div>
      </div>
    </div>
  );
};
